import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c837e92e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-top" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "login-top-title" }, "管理系统"),
  /*#__PURE__*/_createElementVNode("span", { class: "login-top-subtitle" }, "玻璃生产管理")
], -1))
const _hoisted_3 = { class: "login-box" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("自动登录")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 登录 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileOutlined = _resolveComponent("MobileOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_form, _mergeProps({
        name: "custom-validation",
        ref: "loginFormRef",
        model: _ctx.loginModel,
        rules: _ctx.loginRules
      }, _ctx.layout, {
        onFinish: _ctx.handleLogin,
        hideRequiredMark: ""
      }), {
        default: _withCtx(() => [
          _createVNode(_component_a_input_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                required: "",
                "has-feedback": "",
                ref: "name",
                name: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.loginModel.name,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginModel.name) = $event)),
                    type: "text",
                    placeholder: "请输入手机号码",
                    size: "large"
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_component_MobileOutlined, { style: {"color":"#1890ff"} })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            required: "",
            "has-feedback": "",
            name: "password"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_password, {
                value: _ctx.loginModel.password,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginModel.password) = $event)),
                type: "password",
                autocomplete: "off",
                placeholder: "请输入密码",
                size: "large"
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_component_LockOutlined, { style: {"color":"#1890ff"} })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_checkbox, {
            checked: _ctx.checkedAutoLogin,
            "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkedAutoLogin) = $event)),
            onChange: _ctx.handleIsAutoLogin
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["checked", "onChange"]),
          _createVNode(_component_a_form_item, { style: {"margin-top":"30px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit",
                style: {"width":"100%","height":"40px","padding":"0 15px","font-size":"16px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 16, ["model", "rules", "onFinish"])
    ])
  ]))
}